import { render, staticRenderFns } from "./betSingleModal.vue?vue&type=template&id=99d41972&lang=pug&"
import script from "./betSingleModal.vue?vue&type=script&lang=js&"
export * from "./betSingleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports